<template>
  <div class="fe-text-body-xxs fe-text-primary-grey-60 lg:fe-text-body-s">
    {{ `${customerName || createdBy} posted on ${formattedDate}` }}
  </div>
</template>

<script>
  import { formatDate } from "@/utils/utils"

  export default {
    name: "CustomerName",
    props: {
      customerName: {
        type: String,
        default: "",
      },
      createdBy: {
        type: String,
        default: "",
      },
      createdAt: {
        type: String,
        default: "",
      },
    },
    computed: {
      formattedDate() {
        return formatDate(this.createdAt)
      },
    },
  }
</script>
